import {lazy} from 'react';

export const BranchSearchLazy = lazy(() => import(/* webpackChunkName: "branchSearch" */ '.'));
